module.exports = __webpack_public_path__ + "static/media/partager.d3e1f83b.png";